import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
    name: 'stringFilter',
    standalone: true
})
export class StringFilterPipe implements PipeTransform {

  transform(value: any[], q: string) {
    if (!q || q === '') {
      return value;
    }
    const v = value.filter(function (item) {
      if (item.description && item.smartCode) {
        const causalCodeString = item.smartCode + ' ' + item.description
        return causalCodeString.toUpperCase().indexOf(q.toUpperCase()) >= 0;
      } else if (item.description) {
        return item.description.toUpperCase().indexOf(q.toUpperCase()) >= 0;
      }
      return false;
    });
    return v;
  }
}
